import React from 'react';
import { Image } from 'semantic-ui-react';
import { Text } from '../../../typography/Text';
import styles from './styles.module.scss';

export const ImageText = ({ text, imageSrc, alt, children }) => (
  <>
    {children ? (
      <Text xl>
        {children}
      </Text>
    ) : (
      <Text
        xl
        intl={text}
      />
    )}

    <Image
      className={styles.image}
      centered
      src={imageSrc}
      alt={alt}
    />
  </>
);
